export enum ESignatureSignableFileType {
    DOCUMENT = 'document',
    EXPENSE_REQUEST_APPROVAL = 'expense-request-approval',
    EXPENSE_FILE = 'expense-file',
    FUEL_REPORT_APPROVAL = 'fuel-report-approval',
    HR_DOCUMENT_ACK = 'hr-document-ack',
    HR_ORDER = 'hr-order',
    HR_ORDER_ACK = 'hr-order-ack',
}
